import { Injectable, Inject } from '@angular/core';
import { GoToProperties, QueryFeaturesParams } from '../models/hanh-chinh.model';
import { CrudBaseService } from 'nest-crud-typeorm-client';
import { QuanHuyenEntity } from 'lib/models/hanh-chanh.interface';
import { HttpClient } from '@angular/common/http';
import { loadModules } from 'esri-loader';
import { MOL_LIB_TOKEN, LibModuleOptions } from '../lib.config';

@Injectable({
  providedIn: 'root'
})
export class HanhChinhService extends CrudBaseService<QuanHuyenEntity> {
  view: __esri.MapView;
  queryTask: __esri.QueryTask;

  constructor(
    http: HttpClient,
    @Inject(MOL_LIB_TOKEN) private option: LibModuleOptions
  ) {
    super({ apiUrl: option.apiUrl, entity: 'rest/hanh-chinh-huyen' }, http);
    type MapModule = [
      typeof import('esri/tasks/QueryTask')
    ];
    (loadModules(['esri/tasks/QueryTask']) as Promise<MapModule>)
    .then(([QueryTask]) => {
      this.queryTask = new QueryTask({
        url: this.option.map.phuongXaUrl
      });
    });
  }

  async goTo(params: GoToProperties) {
    const features = await this.queryFeatures({
      ...params,
      query: {
        ...params.query,
        num: 1,
        returnGeometry: true,
        outSpatialReference: this.view.spatialReference
      }
    });
    this.view.goTo(features);
  }

  async queryFeatures(params: QueryFeaturesParams): Promise<__esri.Graphic[]> {
    const { maPhuongXa, maQuanHuyen, query } = params;
    let response = [];

    let where: string[] = [];
    if (maPhuongXa) {
      where.push(`${this.option.map.maPhuongXa}='${maPhuongXa}'`);
    }

    if (maQuanHuyen) {
      where.push(`${this.option.map.maQuanHuyen}='${maQuanHuyen}'`);
    }

    const { features } = await this.queryTask.execute({
      where: where.join(' and '),
      ...query
    });
    response = features;
    return response;
  }
}
